import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

const container = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.12 } },
};
const fadeUp = {
  hidden: { opacity: 0, y: 16 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: EASE } },
};
const lineReveal = {
  hidden: { y: "110%" },
  visible: { y: 0, transition: { duration: 1, ease: EASE } },
};
const ruleGrow = {
  hidden: { scaleX: 0 },
  visible: { scaleX: 1, transition: { duration: 1.2, ease: EASE } },
};

export default function ChapterMarker({ number, eyebrow, title, dark = false }) {
  return (
    <div className="relative mb-16 md:mb-24" data-testid={`chapter-marker-${number}`}>
      <span
        aria-hidden="true"
        className={`pointer-events-none absolute -top-16 left-0 select-none font-cinzel text-[22vw] font-bold leading-none md:-top-24 md:text-[15vw] ${
          dark ? "text-abbey-cream/5" : "text-abbey-ink/5"
        }`}
      >
        {number}
      </span>
      <motion.div
        className="relative"
        variants={container}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-80px" }}
      >
        <motion.p
          variants={fadeUp}
          className="font-cinzel text-[11px] tracking-[0.4em] text-abbey-gold md:text-xs"
        >
          {eyebrow.toUpperCase()}
        </motion.p>
        <div className="mt-4 overflow-hidden">
          <motion.h2
            variants={lineReveal}
            className={`font-cormorant text-4xl font-medium tracking-tight sm:text-5xl lg:text-6xl ${
              dark ? "text-abbey-cream" : "text-abbey-ink"
            }`}
          >
            {title}
          </motion.h2>
        </div>
        <motion.div variants={ruleGrow} className="gold-rule mt-8 w-48 origin-left" />
      </motion.div>
    </div>
  );
}
